import type { IOrderState } from '@/store/modules/common/orderState';
import OrderState from '@/store/modules/common/orderState';
import type { IActionParams } from '@/store/modules/index';

const order = new OrderState();

const initialState = (): IOrderState => ({
  ...order.state(),
});

type ActionParams = IActionParams<IOrderState>;

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    ...order.mutations,

    RESET_STATE(state: IOrderState): void {
      Object.assign(state, initialState());
    },
  },
  actions: {
    ...order.actions,

    resetState({ commit }: ActionParams): void {
      commit('RESET_STATE');
    },
  },
  getters: {
    ...order.getters,
  },
};
